import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const opinions = [{
  name: 'Martín Gómez',
  location: 'Rosario, Santa Fe',
  text: 'Mejoré muchísimo la recepción y el control. Ahora puedo girar con la pelota dominada y ver opciones de pase que antes no veía.',
  avatar: 'MG'
}, {
  name: 'Lucas Fernández',
  location: 'La Plata, Buenos Aires',
  text: 'Los tiros libres cambiaron completamente. Entendí la biomecánica y ahora tengo dirección y efecto en cada ejecución.',
  avatar: 'LF'
}, {
  name: 'Tomás Rodríguez',
  location: 'Córdoba',
  text: 'La visión periférica me ayudó a anticipar jugadas. Ahora levanto la cabeza antes de recibir y ya sé a quién pasarle.',
  avatar: 'TR'
}, {
  name: 'Nicolás Díaz',
  location: 'Mendoza',
  text: 'El tomo de liderazgo me dio herramientas para ordenar al equipo cuando el partido se complica. Ahora soy referente en cancha.',
  avatar: 'ND'
}];
export function Opinions() {
  return <section className="bg-white py-16 md:py-24" data-id="element-104">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-105">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-106">
          Lo que dicen los jugadores
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-107">
          {opinions.map((opinion, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 rounded-lg p-6 shadow-md" data-id="element-108">
              <div className="flex gap-1 mb-4" data-id="element-109">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-500 text-yellow-500" data-id="element-110" />)}
              </div>

              <p className="text-gray-700 mb-4 italic" data-id="element-111">"{opinion.text}"</p>

              <div className="flex items-center gap-3" data-id="element-112">
                <div className="w-12 h-12 rounded-full bg-emerald-600 flex items-center justify-center text-white font-bold" data-id="element-113">
                  {opinion.avatar}
                </div>
                <div data-id="element-114">
                  <p className="font-semibold text-gray-900" data-id="element-115">{opinion.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-116">{opinion.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}